module Alert
{
    declare function modal(any);

    export function OpenConfirm(titel: string, message: string, onClose?: (okClicked: boolean) => void) {
        openConfirm("confirm", titel, message, onClose);
    }

    export function OpenBuy(titel: string, message: string, onClose?: (okClicked: boolean) => void) {
        openBuy("confirm", titel, message, onClose);
    }

    export function OpenError(titel: string, message: string | CustomerAPI.WebError, onClose?: () => void)
    {
        if (message instanceof CustomerAPI.WebError)
            openError("error", titel, message.message, onClose);
        else if ((message as any).message != undefined)
            openError("error", titel, (message as any).message, onClose);
        else
            openError("error", titel, message, onClose);
    }

    export function OpenSuccess(titel: string, message: string, onClose?: () => void) {
        openError("success", titel, message, onClose);
    }

    function openError(type: string, titel: string, message: string, onClose?: () => void)
    {
        modal({
            type: type, //Type of Modal Box (alert | confirm | prompt | success | warning | error | info | inverted | primary)
            title: titel, //Modal Title
            text: message, //Modal HTML Content
            size: 'normal', //Modal Size (normal | large | small)
            buttons: [{
                text: localizer["OK"], //Button Text
                val: 'ok', //Button Value
                eKey: true, //Enter Keypress
                addClass: 'btn-light-blue', //Button Classes (btn-large | btn-small | btn-green | btn-light-green | btn-purple | btn-orange | btn-pink | btn-turquoise | btn-blue | btn-light-blue | btn-light-red | btn-red | btn-yellow | btn-white | btn-black | btn-rounded | btn-circle | btn-square | btn-disabled)
                onClick: function (dialog) {
                    return true;
                }
            },],
            center: true, //Center Modal Box?
            autoclose: false, //Auto Close Modal Box?
            callback: (result) => {
                if (onClose != undefined && onClose != null)
                    onClose();
                return true;
            }, //Callback Function after close Modal (ex: function(result){alert(result); return true;})
            onShow: function (r) { }, //After show Modal function
            closeClick: true, //Close Modal on click near the box
            closable: true, //If Modal is closable
            theme: 'atlant', //Modal Custom Theme (xenon | atlant | reseted)
            animate: false, //Slide animation
            background: 'rgba(0,0,0,0.35)', //Background Color, it can be null
            zIndex: 1050, //z-index
            buttonText: {
				ok: 'OK',//TODO: Localize
				yes: 'Yes',//TODO: Localize
				cancel: 'Cancel'//TODO: Localize
            },
            template: '<div class="modal-box"><div class="modal-inner"><div class="modal-title"><a class="modal-close-btn"></a></div><div class="modal-text"></div><div class="modal-buttons"></div></div></div>',
            _classes: {
                box: '.modal-box',
                boxInner: ".modal-inner",
                title: '.modal-title',
                content: '.modal-text',
                buttons: '.modal-buttons',
                closebtn: '.modal-close-btn'
            }
        });
    }

    function openConfirm(type: string, titel: string, message: string, onClose?: (okClicked: boolean) => void) {
        modal({
            type: type, //Type of Modal Box (alert | confirm | prompt | success | warning | error | info | inverted | primary)
            title: titel, //Modal Title
            text: message, //Modal HTML Content
            callback: (result) => {
                if (onClose != undefined && onClose != null)
                    onClose(result);
                return true;
            }, //Callback Function after close Modal (ex: function(result){alert(result); return true;})
            buttonText: {
                ok: localizer["OK"],
                yes: localizer["Yes"],
                cancel: localizer["Cancel"],
            },
        });
    }

    function openBuy(type: string, titel: string, message: string, onClose?: (okClicked: boolean) => void) {
        modal({
            type: type, //Type of Modal Box (alert | confirm | prompt | success | warning | error | info | inverted | primary)
            title: titel, //Modal Title
            text: message, //Modal HTML Content
            callback: (result) => {
                if (onClose != undefined && onClose != null)
                    onClose(result);
                return true;
            }, //Callback Function after close Modal (ex: function(result){alert(result); return true;})
            buttonText: {
                ok: localizer["Buy"],
                yes: localizer["Buy"],
                cancel: localizer["Cancel"]
            },
        });
    }
}